
export default function Hero() {

  return (
    <section className="relative bg-gradient-to-br from-[#EEF5FF] via-[#F8FBFF] to-[#E0EEFF] overflow-hidden">
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(#0066FF 1px, transparent 1px), linear-gradient(90deg, #0066FF 1px, transparent 1px)', backgroundSize: '80px 80px' }}></div>
      </div>

      {/* Content Container */}
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 py-24 pt-24 lg:py-16 lg:min-h-screen flex items-center z-[2]">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          
          {/* Left Content Zone */}
          <div className="space-y-6 lg:space-y-10">

            {/* Main Headline */}
            <h1 className="text-[32px] sm:text-[44px] lg:text-[68px] leading-[1.05] font-black text-[#0A1628] uppercase tracking-tight">
              Innovations in<br />
              Water Technologies
            </h1>

            {/* Subheadline */}
            <p className="text-base sm:text-lg text-[#4A5568] leading-relaxed max-w-[520px]">
              Comprehensive solutions for water treatment and wastewater purification
            </p>
          </div>

          {/* Right: Key Facts Grid */}
          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            
            {/* Card 1: Engineering Projects */}
            <div className="rounded-[20px] sm:rounded-[24px] bg-white border border-[#E8F0FF] p-6 sm:p-10 flex flex-col justify-between min-h-[180px] sm:min-h-[240px] relative overflow-hidden">
              <div className="absolute top-0 right-0 text-[100px] sm:text-[140px] font-black text-[#0066FF] leading-none opacity-[0.03]">10</div>
              <div className="relative z-10">
                <div className="text-[36px] sm:text-[44px] lg:text-[56px] font-black text-[#0066FF] leading-none mb-2 sm:mb-3">
                  10+
                </div>
                <div className="text-xs sm:text-sm text-[#0A1628]/60 font-bold uppercase tracking-wide">
                  Engineering<br/>Projects
                </div>
              </div>
            </div>

            {/* Card 2: Production Facility */}
            <div className="rounded-[20px] sm:rounded-[24px] bg-gradient-to-br from-[#0066FF] to-[#00D4FF] p-6 sm:p-10 flex flex-col justify-between min-h-[180px] sm:min-h-[240px] relative overflow-hidden">
              <div className="absolute top-0 right-0 text-[100px] sm:text-[140px] font-black text-white leading-none opacity-[0.08]">25</div>
              <div className="relative z-10">
                <div className="text-[36px] sm:text-[44px] lg:text-[56px] font-black text-white leading-none mb-2 sm:mb-3">
                  2,500+
                </div>
                <div className="text-xs sm:text-sm text-white/80 font-bold uppercase tracking-wide">
                  m² Production<br/>Facility
                </div>
              </div>
            </div>

            {/* Card 3: Capacity Range */}
            <div className="rounded-[20px] sm:rounded-[24px] bg-[#0A1628] p-6 sm:p-10 flex flex-col justify-between min-h-[180px] sm:min-h-[240px] relative overflow-hidden">
              <div className="absolute top-0 right-0 text-[100px] sm:text-[140px] font-black text-white leading-none opacity-[0.05]">50</div>
              <div className="relative z-10">
                <div className="text-[36px] sm:text-[44px] lg:text-[56px] font-black text-white leading-none mb-2 sm:mb-3">
                  50–6000
                </div>
                <div className="text-xs sm:text-sm text-white/70 font-bold uppercase tracking-wide">
                  m³/h Capacity<br/>Range
                </div>
              </div>
            </div>

            {/* Card 4: EPC Approach */}
            <div className="rounded-[20px] sm:rounded-[24px] bg-white border border-[#E8F0FF] p-6 sm:p-10 flex flex-col justify-between min-h-[180px] sm:min-h-[240px] relative overflow-hidden">
              <div className="absolute top-0 right-0 text-[100px] sm:text-[140px] font-black text-[#0066FF] leading-none opacity-[0.03]">E</div>
              <div className="relative z-10">
                <div className="text-[36px] sm:text-[44px] lg:text-[56px] font-black text-[#0066FF] leading-none mb-2 sm:mb-3">
                  EPC
                </div>
                <div className="text-xs sm:text-sm text-[#0A1628]/60 font-bold uppercase tracking-wide">
                  Full-Cycle<br/>Approach
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
